<template>
  <div class="dt-row-user">
    <!-- New row -->
    <div class="dt-row-detail" :class="{'active': index % 2 == 1}">
      <div class="body-col" :style="{ width: columnWidth.firstName.size ? (columnWidth.firstName.size + 'px') : '12%' }">
        {{ userInfo.firstName }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.lastName.size ? (columnWidth.lastName.size + 'px') : '12%' }">
        {{ userInfo.lastName }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.email.size ? (columnWidth.email.size + 'px') : '22%' }">
        {{ userInfo.email }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.clientAccount.size ? (columnWidth.phone.size + 'px') : '12%' }">
        {{ userInfo.phoneNumber }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.clientAccount.size ? (columnWidth.clientAccount.size + 'px') : '10%' }">
        {{ clientName }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.role.size ? (columnWidth.role.size + 'px') : '10%' }">
        {{ showRoleText }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.status.size ? (columnWidth.status.size + 'px') : '14%' }">
        {{ userInfo.status || "Account is not on Cognito" }}
      </div>
      <div class="body-col col-action" :style="{ width: columnWidth.action.size ? (columnWidth.action.size + 'px') : '8%' }">
        <div class="wrapper" @click="editUserInfo()">
          <span>
            <Icon v-b-tooltip.hover.bottom :title="instructions.edit" name="pencil" class="icon"></Icon>
          </span>
        </div>
        <div class="wrapper" @click="deleteUser()">
          <span>
            <Icon v-b-tooltip.hover.bottom :title="instructions.delete" :name="iconNames.trashO" class="icon"></Icon>
          </span>
        </div>
        <div @click="forceUserResetPassword()" class="wrapper">
          <span><img src="../../../static/img/user-lock.svg" v-b-tooltip.hover.bottom :title="instructions.forceResetPassword" class="icon"/></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon';
import constants from '../../_consts';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'UserRow',
  components: {
    Icon
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    userInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      instructions: constants.instructions,
      iconNames: constants.iconNames
    };
  },
  computed: {
    showRoleText () {
      let roles = constants.USER_ROLE;
      let userRole = this.userInfo.role;
      if (userRole.toLowerCase() === roles.client.toLowerCase() || userRole.toLowerCase() === roles.clientManager.toLowerCase()) {
        return 'Client';
      }
      if (userRole.toLowerCase() === roles.accountManager.toLowerCase() || userRole.toLowerCase() === roles.secondaryAccountManager.toLowerCase()) {
        return 'AM';
      }
      if (userRole.toLowerCase() === roles.eventManager.toLowerCase()) {
        return 'EM';
      }
      if (userRole.toLowerCase() === roles.admin.toLowerCase()) {
        return 'Admin';
      }
      if (userRole.toLowerCase() === roles.staff.toLowerCase()) {
        return 'Staff';
      }
      return '';
    },
    clientName () {
      return this.userInfo.client.id === 0 ? '' : this.userInfo.client.clientName;
    },
    ...mapGetters({
      columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
    })
  },
  methods: {
    editUserInfo () {
      let modalData = {
        action: constants.modalAction.editUser,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    },
    deleteUser () {
      if (this.userInfo.role === constants.USER_ROLE.admin) {
        Vue.prototype.$toastr('error', 'Can not delete user with role Admin.', '');
        return;
      }
      let modalData = {
        action: constants.modalAction.deleteUser,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    },
    forceUserResetPassword () {
      let modalData = {
        action: constants.modalAction.forceUserResetPassword,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';
.dt-row-user{
  font-family: "Open Sans";
  background-color: #ffffff;
  .active{
    .body-col{
      background-color: #f5f5f5;
    }
  }
  .dt-row-detail{
    .body-col{
      color: #231F20;
      font-size: 14px;
      display: flex;
      align-items: center;

      &.col-action{
        .wrapper{
          margin-left: 4px;
        }
      }

      .wrapper{
        width: 24px;
        background-color: #0080a5;
        height: 24px;
        margin-top: 5px;
        border-radius: 4px;
        position: relative;
        display: inline-block;
        .icon{
          // margin-top: 10px;
          position: absolute;
          top: 2px;
          left: 2px;
          background-color: @blue;
          color: #fff;
          height: 20px;
          width: 20px;
          border-radius: 4px;
          &:hover{
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// UserRow.vue?2c580562